// Naming conventions
export const SEPARATOR                          = '--';
export const SEP                                = SEPARATOR;
export const CONFIG_PANEL                       = 'cp' + SEP;
export const CONFIG_OPTION                      = 'cf' + SEP;
export const PRICE_SCALE                        = 'ps' + SEP;
export const MODAL                              = 'modal' + SEP;
export const STATE                              = 'state';

// Props - base
export const CF_NODE                            = 'cf_node';
export const PARENT_NODE                        = 'parent_node';
export const ID                                 = 'id';
export const KEY                                = 'key';
export const LABEL                              = 'label';
export const NAME                               = 'name';
export const PATH                               = 'path';
export const PROP                               = 'prop';
export const PROPS                              = 'props';
export const QUANTITY                           = 'quantity';
export const VALUE                              = 'value';

// export const CHECKBOX                           = 'checkbox';
// export const FILES                              = 'files';
// export const NUMBER                             = 'number';
// export const RADIO                              = 'radio';
// // export const TEXT                               = 'TEXT';
// export const TEXT                               = 'text';
// // export const TEXTAREA                           = 'TEXTAREA';
// export const TEXTAREA                           = 'textarea';

// Props - misc
export const CALC__ONCE_PER_PIECE               = 'CALC__ONCE_PER_PIECE';
export const CHILDREN                           = 'children';
export const COLORS_INCLUDED                    = 'COLORS_INCLUDED';
export const COLORS_MAX                         = 'COLORS_MAX';
export const COLORS_MIN                         = 'COLORS_MIN';
export const COLORS_QUANTITY                    = 'COLORS_QUANTITY';
export const COLORS_SELECTED                    = 'COLORS_SELECTED';
export const INCLUDED_SCOPE                     = 'INCLUDED_SCOPE';
export const INPUT                              = 'INPUT';
export const INPUT_TYPE                         = 'input_type';
export const ITEMS_INCLUDED                     = 'ITEMS_INCLUDED';
export const MODEL_ID                           = 'model_id';
export const NR_SELECTED                        = 'nr_selected';
export const PARENT_ID                          = 'parent_id';
export const PARENT_MODEL_ID                    = 'parent_model_id';
export const PICKED_SWATCH                      = 'picked_swatch';
export const QUANTITY_INPUT                     = 'QUANTITY_INPUT';
export const QUANTITY_MAX                       = 'QUANTITY_MAX';
export const QUANTITY_MIN                       = 'QUANTITY_MIN';
export const QUANTITY_MIN_CF                    = 'min_quantity_cf';
export const REPEATABLE                         = 'repeatable';
export const SELECTED_LABELS                    = 'SELECTED_LABELS';
export const SELECTED_MAX                       = 'SELECTED_MAX';
export const SET_DIRECTLY                       = 'set_directly';
export const SET_IN_PROP_LIBRARY                = 'set_in_prop_library';
export const SET_PROP_OBJECT                    = 'SET_PROP_OBJECT';
export const THICKNESS_INPUT                    = 'THICKNESS_INPUT';
export const THICKNESS_MAX                      = 'THICKNESS_MAX';
export const PRICES_CF                          = 'prices_cf';
export const PRICES_CF_BY_CAT                   = 'prices_cf_by_cat';
export const PRICES_SHOW_ONLY                   = 'prices_show_only'

// Props - validation
export const VALIDATION                         = 'validation';
export const VALIDATED                          = 'validated';
export const REQUIRED                           = 'required';
export const ERRORS                             = 'errors';


// Props - flags
export const ACTIVE                             = 'active';
export const ACTIVATED                          = 'activated';
export const DISABLED                           = 'disabled';
export const DISABLED_BY                        = 'disabled_by';
export const DISPLAY_ONLY                       = 'DISPLAY_ONLY';
export const EXPANDED                           = 'expanded';
export const HIDDEN                             = 'hidden';
export const INVALIDATED_BY                     = 'invalidated_by';
export const IS_INCLUDED                        = 'is_included';
export const SELECTED                           = 'selected';
export const SCROLL_INTO_VIEW                   = 'scroll_into_view';
export const SKIP_UPDATE_COOKIE                 = 'skip_update_cookie';

// Values
export const ON                                 = 'on';
export const OFF                                = 'off';
// Values Database: price types
export const PRICE_ONCE                         = 'ONCE';
export const PRICE_PER_ORDER                    = 'PER_ORDER';
export const PRICE_PER_PIECE                    = 'PER_PIECE';
export const PER_PIECE_MIN_COLOR                = 'PER_PIECE_MIN_COLOR';
export const PRICE_AT_REQUEST                   = 'prijs op aanvraag';
// Values Database: descriptions
export const POPUP_CONTENT                      = 'POPUP_CONTENT';

// Types
export const BOOL                               = 'boolean';
export const NUMBER                             = 'number';
export const TRUE_UNLESS_0                      = 'TRUE_UNLESS_0';

// Actions
export const ACTION                             = 'action'
export const ADD                                = 'ADD';
export const DISCONTINUE                        = 'DISCONTINUE';
export const FORCE_UPDATE                       = 'FORCE_UPDATE';
export const REMOVE                             = 'REMOVE';
export const SHOW                               = 'SHOW';
export const SET                                = 'SET';
export const TRACK                              = 'TRACK';
export const UPDATE                             = 'UPDATE';


// -- URL PARAMETERS ---- ----------------------------------------------------------------------------------------------
export const URL_PARA__QUANTITY                 = 'q';
export const URL_PARA__REORDER                  = 'reorder';

// -- IDS USED IN MODELS  ----------------------------------------------------------------------------------------------

export const ID__HERHALING                      = 'HERHALING';
export const ID__JA                             = 'JA';

// -- GENERIC ACTION ---------------------------------------------------------------------------------------------------
// export const EXECUTE_CALLBACKS                  = MOD_CONFIGURATOR + '/EXECUTE_CALLBACKS';
// -- END GENERIC MUTATIONS ------------------------------------------------------------------------------------------

// -- GENERIC MUTATIONS ----------------------------------------------------------------------------------------------
// export const MAP__DELETE                        = MOD_CONFIGURATOR + '/MAP__DELETE';
// -- END GENERIC MUTATIONS ------------------------------------------------------------------------------------------
